// extracted by mini-css-extract-plugin
export default {"tableData":"style--tableData--ddcad4","right":"style--right--ae79a5","left":"style--left--83ac82","center":"style--center--0ca536"};